// import Login from 'containers/views/Login'
import Home from 'containers/views/Home'
import searchResult from 'containers/views/SearchResult'
import Collection from 'containers/views/Collection'
import CourseWare from 'containers/views/CourseWare'
import Topic from 'containers/views/Topic'
import TopicDetail from 'containers/views/TopicDetail'
import UserCenter from 'containers/views/UserCenter'
import Course from 'containers/views/Course'
import Feedback from 'containers/views/Feedback'
import UnAuthorized from 'containers/shared/UnAuthorized'
import SearchResultDetail from 'containers/views/SearchResultDetail'
import Levelup from 'containers/views/Levelup'
import Housework from 'containers/views/Family/Housework'
import HouseworkDetail from 'containers/views/Family/Housework/detail'
import HouseworkList from 'containers/views/Family/Housework/list'
import Team from 'containers/views/Family/Team'
import TeamListDetail from 'containers/views/Family/Team/listDetail'
import TeamActDetail from 'containers/views/Family/Team/activityDetail'
import TeamActIntro from 'containers/views/Family/Team/activityIntro'
import TeamList from 'containers/views/Family/Team/list'

import Travel from 'containers/views/Family/Honor/pages/Travel'
import License from 'containers/views/Family/Honor/pages/License'
import Hero from 'containers/views/Family/Honor/pages/YearHero'
import QuarterHero from 'containers/views/Family/Honor/pages/Hero'

// 讲师进阶=>荣耀殿堂-专业学习-从业考证
import Glory from 'containers/views/Lecturer/Glory'
import Study from 'containers/views/Lecturer/Study'
import CourseCheck from 'containers/views/Lecturer/CourseCheck'
import Gather from 'containers/views/Lecturer/Gather'

const authorizedRoutes = [
  {
    path: '/home',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Home,
    pageTitle: '首页',
  },
  {
    path: '/searchresult',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: searchResult,
    pageTitle: '搜索结果',
  },
  {
    path: '/searchresult/detail/:type',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: SearchResultDetail,
    pageTitle: '搜索结果',
  },
  {
    path: '/collection',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Collection,
    pageTitle: '藏经阁',
  },
  {
    path: '/courseware',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: CourseWare,
    pageTitle: '课件库',
  },
  {
    path: '/topics',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Topic,
    pageTitle: '专题',
  },
  {
    path: '/feedback',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Feedback,
    pageTitle: '意见反馈',
  },
  {
    path: '/topicdetail/:id',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: TopicDetail,
    pageTitle: '专题列表',
  },
  {
    path: '/usercenter',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: UserCenter,
    pageTitle: '个人中心',
  },
  {
    path: '/usercenter/:tab',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: UserCenter,
    pageTitle: '个人中心',
  },
  {
    path: '/course/:id',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Course,
    pageTitle: '课程详情页',
  },
  {
    path: '/levelup',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Levelup,
    pageTitle: '员工进阶',
  },
  {
    path: '/housework',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Housework,
    pageTitle: '经传家事',
  },
  {
    path: '/housework/detail/:id',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: HouseworkDetail,
    pageTitle: '经传家事',
  },
  {
    path: '/housework/list/:id',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: HouseworkList,
    pageTitle: '经传家事',
  },
  {
    path: '/team',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Team,
    pageTitle: '经传人',
  },
  {
    path: '/team/detail/:id',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: TeamListDetail,
    pageTitle: '经传人',
  },
  {
    path: '/team/actintro/:id',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: TeamActIntro,
    pageTitle: '经传人',
  },
  {
    path: '/team/actdetail/:id',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: TeamActDetail,
    pageTitle: '经传人',
  },
  {
    path: '/team/list/:id',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: TeamList,
    pageTitle: '经传人',
  },
  {
    path: '/honor',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: License,
    pageTitle: '经传荣誉',
  },
  {
    path: '/honor/travel',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Travel,
    pageTitle: '出国游',
  },
  {
    path: '/honor/license',
    exact: false,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: License,
    pageTitle: '资质牌照',
  },
  {
    path: '/honor/yearhero',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Hero,
    pageTitle: '英雄榜',
  },
  {
    path: '/honor/quarterhero',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: QuarterHero,
    pageTitle: '英雄榜',
  },
  {
    path: '/glory',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Glory,
    pageTitle: '荣耀殿堂',
  },
  {
    path: '/glory/gather',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Gather,
    pageTitle: '投资顾问',
  },
  {
    path: '/study',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: Study,
    pageTitle: '专业学习',
  },
  {
    path: '/coursecheck',
    exact: true,
    permissions: ['admin', 'user'],
    unauthorized: UnAuthorized,
    component: CourseCheck,
    pageTitle: '专业学习',
  },
]

const normalRoutes = [
  {
    path: '/',
    exact: true,
    redirect: '/home',
  },
]

const combineRoutes = [...authorizedRoutes, ...normalRoutes]

export { authorizedRoutes, normalRoutes, combineRoutes }
